<div class="modal-header no-icon">
    <h3 class="modal-title">Acknowledgement History</h3>
    <button type="button" (click)="close()" aria-label="Close" class="close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="bottom-buffer">
        <label>Viewing history for</label>
        <ng-select
            *ngIf="canViewOthers; else viewingSelf"
            [items]="personnel"
            [(ngModel)]="selectedPersonId"
            [ngModelOptions]="{ standalone: true }"
            bindValue="id"
            [clearable]="false"
            appendTo="body"
            [searchFn]="personSearch"
            [loading]="loadingPersonnel"
            [virtualScroll]="true"
            (change)="onPersonChange()"
            (open)="onPersonSelectOpen()"
            (scrollToEnd)="onPersonSelectScroll()"
            (search)="onPersonSelectSearch($event)"
            (close)="onPersonSelectClose()"
        >
            <ng-template ng-label-tmp let-item="item">
                {{ item | formatPerson }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
                {{ item | formatPerson }}
            </ng-template>
        </ng-select>
        <ng-template #viewingSelf>
            <p class="form-control-static" *ngIf="selectedPerson as person">
                {{ person | formatPerson }}
            </p>
        </ng-template>
    </div>
    <ng-container *ngIf="acknowledgementHistory">
        <div>
            <table class="table">
                <thead>
                    <tr>
                        <th>Version</th>
                        <th>Acknowledged</th>
                        <th>Acknowledgement time</th>
                        <th>Original File Name</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="
                            let version of versionsWithAcknowledgement;
                            let index = index
                        "
                    >
                        <td class="wordwrap">Version {{ index }}</td>
                        <td class="wordwrap">
                            {{
                                version.acknowledgementTime != null
                                    ? 'Yes'
                                    : 'No'
                            }}
                        </td>
                        <td class="wordwrap">
                            {{ version.acknowledgementTime | formatDateTime }}
                        </td>
                        <td class="wordwrap">
                            {{ version.originalFileName }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
</div>
